import {useCollapsedKeys} from '@/hooks';

import type {TrustAccountGroupFold} from '../utils';

const STORAGE_KEY = 'trust-accounts:collapsedStatusGroups';

/**
 * Which status groups the reader folded, remembered per list (not per view), so the table and the
 * card grid open the same way; every group starts expanded.
 */
export function useTrustAccountCollapsedGroups(): TrustAccountGroupFold {
  return useCollapsedKeys(STORAGE_KEY);
}
